<template>
  <div>
    <h2>每日班表</h2>
    <!--
    <el-link type="primary" :href="lineLink3" target="_blank" style="font-size: 18px"
      >徵求美容師(請點我)</el-link
    >
    
    <h2><label style="color: red">網站調整中</label></h2>
    -->
    <br />
    <label style="color: red">點圖可放大，表格可往右滑</label>
  </div>

  <div class="container" id="con1">
    <ul class="nav nav-tabs" id="nav">
      <li v-for="tab in tabs" v-bind:key="tab" class="nav-item">
        <a
          href="#"
          class="nav-link"
          :class="{ active: tab.isActive }"
          @click="setActive(tab)"
          >{{ tab.name }}</a
        >
      </li>
      <li class="nav-item dropdown">
        <a
          class="nav-link dropdown-toggle"
          data-bs-toggle="dropdown"
          href="#"
          role="button"
          aria-expanded="false"
          id="DropdownMenu"
          >更多</a
        >
        <ul class="dropdown-menu"></ul>
      </li>
    </ul>

    <div class="tab-content">
      <Spa_Daily_El
        :date="refreshdate"
        :spa="spa_id"
        :conWidth="conWidth"
        :rule2="rule2"
      ></Spa_Daily_El>
    </div>
  </div>
</template>

<script>
import $ from "jquery";
import axios from "axios";
import Spa_Daily_El from "@/components/Spa_Daily_El.vue";

export default {
  data() {
    return {
      tabs: [],
      activeTab: {},
      conWidth: "",
      spa_id: "",
      refreshdate: "",
      rule2: "",
      lineLink3: "",
    };
  },
  components: {
    Spa_Daily_El,
  },
  methods: {
    selectAll() {
      axios
        .post("/php/spa_config.php", {
          action: "selectAll",
        })
        .then((res) => {
          this.tabs = res.data;

          var findTab = this.tabs.find((e) => e.seq == "1");
          findTab.isActive = true;
          this.spa_id = findTab.id;
          this.refreshdate = findTab.refreshdate;
          this.rule2 = "<h6 style='color:red'>" + findTab.rule2 + "</h6>";
        })
        .catch((error) => {
          console.error(error);
        })
        .finally(() => {
          this.setDropdown("#nav", 50);
        });

      axios
        .post("/php/spa_config.php", {
          action: "selectLink",
        })
        .then((res) => {
          var findLine3 = res.data.find((e) => e.code === "lineLink3");
          if (findLine3) {
            this.lineLink3 = findLine3.text;
          }
        })
        .catch((error) => {
          console.error(error);
        });
    },
    setActive: function (tab) {
      tab.isActive = true;
      this.activeTab = tab;

      this.spa_id = tab.id;
      this.refreshdate = tab.refreshdate;
      this.rule2 = "<h6 style='color:red'>" + tab.rule2 + "</h6>";

      var name = this.activeTab.name;
      this.tabs.forEach(function (tab) {
        if (tab.name !== name) {
          tab.isActive = false;
        }
      });
    },
    setDropdown: function (menu, maxHeight) {
      var nav = $(menu);
      var navHeight = nav.innerHeight();
      if (navHeight >= maxHeight) {
        $(menu + " .dropdown").removeClass("d-none");
        $(".navbar-nav").removeClass("w-auto").addClass("w-100");

        while (navHeight > maxHeight) {
          //  add child to dropdown
          var children = nav.children(menu + " li:not(:last-child)");
          var count = children.length;
          $(children[count - 1]).prependTo(menu + " .dropdown-menu");
          navHeight = nav.innerHeight();
        }
        $(".navbar-nav").addClass("w-auto").removeClass("w-100");
      } else {
        var collapsed = $(menu + " .dropdown-menu").children(menu + " li");

        if (collapsed.length === 0) {
          $(menu + " .dropdown").addClass("d-none");
        }

        while (
          navHeight < maxHeight &&
          nav.children(menu + " li").length > 0 &&
          collapsed.length > 0
        ) {
          //  remove child from dropdown
          collapsed = $(menu + " .dropdown-menu").children("li");
          $(collapsed[0]).insertBefore(nav.children(menu + " li:last-child"));
          navHeight = nav.innerHeight();
        }

        if (navHeight > maxHeight) {
          this.setDropdown(menu, maxHeight);
        }
      }
    },
    resizeHandler: function () {
      this.setDropdown("#nav", 50);
    },
  },
  created: function () {
    window.addEventListener("resize", this.resizeHandler);
  },
  unmounted() {
    window.removeEventListener("resize", this.resizeHandler);
  },
  mounted() {
    this.selectAll();
    this.conWidth = $("#con1").width();
  },
};
</script>

<style>
.nav-tabsa {
  position: fixed;
  z-index: 100;
}
</style>
